import styled from "styled-components";

export const ActivityRuleAndCoupon = styled.div`
  position: absolute;
  right: 0;
  top: -48px;
  display: flex;
  .rule-text {
    span {
      color: #9fa3a6;
      :hover {
        color: var(--main-color);
      }
    }
    ::after {
      content: "|";
      display: inline-block;
      color: #9fa3a6;
      margin: 0 10px;
    }
  }
`;

export const FoxCouponCode = styled.div`
  color: #9fa3a6;
  cursor: pointer;
  :hover {
    color: var(--main-color);
  }
`;
